/* eslint-disable import/no-unresolved */
import React from "react";
import ShopSiteHomeMain from "components/pages/user/home/ShopSiteHomeMain";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleShopSiteHomeMain = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopSiteHomeMain {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleShopSiteHomeMain);
